import type { ReactNode } from "react";

type Orientation = "horizontal" | "vertical";
type Align = "start" | "center" | "end" | "between" | "around";

interface LinearLayoutProps {
  children: ReactNode;
  orientation?: Orientation;
  gap?: number;
  align?: Align;
  className?: string;
}

export default function LinearLayout({
  children,
  orientation = "vertical",
  gap = 0,
  align = "start",
  className = "",
}: Readonly<LinearLayoutProps>) {
  const flexDirection = orientation === "horizontal" ? "flex-row" : "flex-col";

  const alignMap: Record<Align, string> = {
    start: "justify-start",
    center: "justify-center",
    end: "justify-end",
    between: "justify-between",
    around: "justify-around",
  };

  const classes = [
    "flex",
    flexDirection,
    `gap-${gap}`,
    alignMap[align],
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return <div className={classes}>{children}</div>;
}
